// Unpublished Work © 2026 Deere & Company.
import {DEFAULT_COUNTRIES, FOOTER_MAP} from '../constants/footer-links';

function hasValidLocaleKey(key: string): boolean {
    return key in FOOTER_MAP;
}
function hasValidCountry(key: string): boolean {
    return key in DEFAULT_COUNTRIES;
}

export function getFooterData(locale: string) {
    const key = locale.toLowerCase();

    if (hasValidLocaleKey(key)) {
        //@ts-expect-error - TypeScript does not recognize that we've already checked for the key in FOOTER_MAP
        return FOOTER_MAP[key];
    }

    if (hasValidCountry(key)) {
        //@ts-expect-error - TypeScript does not recognize that we've already checked for the key in FOOTER_MAP
        const footerKey = `${key}-${DEFAULT_COUNTRIES[key]}`;

        //@ts-expect-error - TypeScript does not recognize that we've already checked for the key in FOOTER_MAP
        return FOOTER_MAP[footerKey];
    }

    return FOOTER_MAP['en-us'];
}
